<template>

    <div :class="{'active' : isActive}"
         class="w-full border border-offBlack flex mb-4 available-options" >
        <div class="w-3/4 relative z-20" :class="{'flex' : optionData.image}">
            <div class="w-1/3 self-center" v-if="optionData.image">
                <div class="image-wrap cursor-pointer"
                     @click="$emit('openModal', 'modal-' + optionData.id + '' + optionData.categoryId)">
                    <img loading="lazy" :src="optionData.image" :alt="optionData.title" :title="optionData.title">
                </div>
            </div>
            <div class="checkbox-text" :class="{'w-2/3' : optionData.image}">
                <span class="upgrade">{{ optionData.prefix }}</span>
                <h3 class="description">{{ optionData.title }}
                    <svg v-if="optionData.description"
                         @click="$emit('openModal', 'modal-' + optionData.id + '' + optionData.categoryId)"
                         xmlns="http://www.w3.org/2000/svg" class="w-4 inline cursor-pointer" fill="currentColor"
                         viewBox="0 0 512 512">
                        <!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                        <path
                            d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM256 464c-114.7 0-208-93.31-208-208S141.3 48 256 48s208 93.31 208 208S370.7 464 256 464zM296 336h-16V248C280 234.8 269.3 224 256 224H224C210.8 224 200 234.8 200 248S210.8 272 224 272h8v64h-16C202.8 336 192 346.8 192 360S202.8 384 216 384h80c13.25 0 24-10.75 24-24S309.3 336 296 336zM256 192c17.67 0 32-14.33 32-32c0-17.67-14.33-32-32-32S224 142.3 224 160C224 177.7 238.3 192 256 192z"/>
                    </svg>
                </h3>
                <p class="text-gold total-price">+ {{ formatPrice(optionData.price) }}</p>
            </div>
        </div>
        <div class="w-1/4 flex items-center justify-center cursor-pointer relative z-20" @click="handleAddOn">
            <input v-if="displayAs === 'checkbox'" class="form-checkbox" type="checkbox" :checked="isActive">
            <input v-if="displayAs === 'radio'" class="form-radio" type="radio" :checked="isActive"
                   :data-groupid="optionData.categoryId" :value="optionData.id">
        </div>
    </div>
</template>


<script>
import {formatPrice} from "./Functions";

export default {
    props: {
        optionData: {
            required: false
        },
        isActive: {
            required: false
        },
        displayAs: {
            // checkbox or radio button
            required: false
        }
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price)
        },
        removeAddOn(addOnId) {
            this.$emit('removeAddOn', addOnId)
        },
        newAddOn(addOn) {
            this.$emit('newAddOn', addOn)
        },
        handleAddOn() {
            let container = document.querySelector('#accordion-pconfigurator')
            let radioGroup = container.querySelectorAll('input[data-groupid="' + this.optionData.categoryId + '"]')



            if (this.isActive === true) {

                // remove add on from the selected add ons if this is a checkbox
                if (this.displayAs === 'radio' && radioGroup?.length === 1) {
                    //
                } else {
                    this.removeAddOn(this.optionData.id)
                }

            } else {

                // remove add on from the selected add ons if this is a radio button;
                // first remove all radio buttons selected from this category (1) and then add this option as selected (2)
                if (this.displayAs === 'radio') { // (1)
                    radioGroup?.forEach(x => this.removeAddOn(x.value * 1))
                }

                this.newAddOn(this.optionData) // (2)
            }
        },
    },
    setup(props) {

        //

    },
}
</script>
